/* ============================================================
   FORGEDLOOT — SHOPPING EXPERIENCE LAYER (JS)
   Approved scope (2026-08-24):
     2. Trust row under the buy buttons
     3. Sticky Add-to-Cart bar on mobile
   No dependencies. Every step guards for missing elements.
   ============================================================ */
(function () {
  'use strict';

  function isMobile() { return window.matchMedia('(max-width: 860px)').matches; }

  /* Only real product pages. Collection grids and the homepage carry
     quick-add buttons too, and without this guard the trust row got
     injected there as well. */
  function isProductPage() {
    return /\/products\/[^/]+/.test(window.location.pathname) &&
           document.querySelector('form[action*="/cart/add"]') !== null;
  }

  /* the real add-to-cart button, whatever Horizon calls it today */
  function findAtc() {
    return document.querySelector(
      'product-form button[type="submit"], form[action*="/cart/add"] button[type="submit"],' +
      'button[name="add"], .product-form__submit, add-to-cart-component button'
    );
  }

  /* ---------- 2. TRUST ROW ---------------------------------- */
  var ICONS = {
    ship: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
    forge: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2s4 4.5 4 8a4 4 0 0 1-8 0c0-3.5 4-8 4-8z"/><path d="M8.5 14.5C7 16 6 17.6 6 19a6 6 0 0 0 12 0c0-1.4-1-3-2.5-4.5"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>'
  };

  function trustRow() {
    var items = [
      { i: 'ship',  t: 'Free shipping<br>over $50' },
      { i: 'forge', t: 'Made to order<br>just for you' },
      { i: 'lock',  t: 'Secure<br>checkout' }
    ];
    var el = document.createElement('div');
    el.className = 'fl-trust';
    el.innerHTML = items.map(function (x) {
      return '<div class="fl-trust__item"><span class="fl-trust__ico">' + ICONS[x.i] +
             '</span><span class="fl-trust__txt">' + x.t + '</span></div>';
    }).join('');
    return el;
  }

  function initTrust() {
    if (!isProductPage()) return;
    if (document.querySelector('.fl-trust')) return;
    var atc = findAtc();
    if (!atc) return;

    /* Sit BELOW the whole buy-button group (Add to cart + Buy it now),
       never between them. The accelerated-checkout button renders last,
       so anchor to it when it exists. */
    var pay = document.querySelector(
      '.shopify-payment-button, .shopify-payment-button__button, additional-checkout-buttons'
    );
    var anchor = pay
      ? (pay.closest('.shopify-payment-button, additional-checkout-buttons') || pay)
      : (atc.closest('.product-form__buttons, product-form') || atc);

    while (anchor.parentElement &&
           anchor.parentElement !== document.body &&
           anchor.parentElement.children.length === 1) {
      anchor = anchor.parentElement;
    }
    if (!anchor.parentElement) return;
    anchor.parentElement.insertBefore(trustRow(), anchor.nextSibling);
  }

  /* ---------- 3. STICKY ADD TO CART (mobile) ---------------- */
  function initStickyAtc() {
    if (!isProductPage()) return;
    if (!isMobile()) return;
    if (document.querySelector('.fl-sticky-atc')) return;

    var atc = findAtc();
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!atc || !form) return;

    var titleEl = document.querySelector('.product-title, .product__title, h1');
    var priceEl = document.querySelector('.price__current, .price-item--regular, .product-price, [class*="price"]');
    var title = titleEl ? titleEl.textContent.trim() : 'This piece';
    var price = priceEl ? priceEl.textContent.trim().split('\n')[0] : '';

    var bar = document.createElement('div');
    bar.className = 'fl-sticky-atc';
    bar.innerHTML =
      '<div class="fl-sticky-atc__info">' +
        '<div class="fl-sticky-atc__title"></div>' +
        '<div class="fl-sticky-atc__price"></div>' +
      '</div>' +
      '<button type="button" class="fl-sticky-atc__btn">Add to cart</button>';
    /* textContent, never innerHTML, for anything product-derived */
    bar.querySelector('.fl-sticky-atc__title').textContent = title;
    bar.querySelector('.fl-sticky-atc__price').textContent = price;

    document.body.appendChild(bar);
    document.body.classList.add('fl-has-sticky-atc');

    /* proxy to the real button so variant + validation logic still runs */
    bar.querySelector('.fl-sticky-atc__btn').addEventListener('click', function () {
      atc.click();
      atc.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });

    /* show only while the real button is off screen */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle('is-visible', !e.isIntersecting);
        });
      }, { rootMargin: '-10px 0px -120px 0px' }).observe(atc);
    }
  }

  function boot() {
    initTrust();
    initStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* Horizon re-renders sections on variant change */
  document.addEventListener('shopify:section:load', boot);
})();
